import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { pickRandomSlide } from '@/config/login/spireonFleetMarketingSlides';
import FleetLocateMarketingPanel from './FleetLocateMarketingPanel';
import LoginForm from './Form';

const FleetLocateComponent = ({ Styled, ...rest }) => {
  const slide = useMemo(() => pickRandomSlide(), []);

  return (
    <Styled.LoginParentWrapper>
      <Styled.LeftPanel>
        <FleetLocateMarketingPanel slide={slide} Styled={Styled} />
      </Styled.LeftPanel>
      <Styled.RightPanel>
        <Styled.LoginWrapper>
          <LoginForm {...rest} Styled={Styled} hasRegistration={false} />
        </Styled.LoginWrapper>
      </Styled.RightPanel>
    </Styled.LoginParentWrapper>
  );
};

FleetLocateComponent.propTypes = {
  Styled: PropTypes.object.isRequired,
};

export default FleetLocateComponent;
